import { useState } from 'react';

import { useLocation, useNavigate } from '@reach/router';
import { useDispatch, useSelector } from 'react-redux';

import genericModelTypes from '../../provider/models/genericModelTypes';
import { fakeDelay, linkCheckSlash } from '../../provider/utility';
import { selectedCity } from '../../store/actions';
import { serviceTypes } from '../../store/initData/services';
import AccordionWithSearch from '../AccordionWithSearch';
import FormLabel from '../FormLabel/FormLabel';
import LoadingBar from '../LoadingBar/LoadingBar';
import SingleInputPage from './SingleInputPage/SingleInputPage';

export default function CityPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const currentPage = useSelector((store) => store.state.page);
  const currentService = useSelector((store) => store.state.service);
  const isWorkshopService = currentService.value === serviceTypes.workshop;

  const cityFormLabel = useSelector((store) => store.data.cityFormLabel);
  const availableFranchises = useSelector((store) => store.data.franchises);
  const availableCities = availableFranchises?.map((fr) => ({
    text: fr.name,
    value: fr.id,
    franchise: fr,
  }));
  const currentCity = useSelector((store) => store.state.city);
  const currentAge = useSelector((store) => store.state.age);
  const ageLinkValue = currentAge?.value || 0;

  const cityPageTexts = useSelector((store) => store.data.cityPage);

  const handleSelection = (item) => {
    dispatch(selectedCity(item));
    setLoading(true);
    fakeDelay(() => {
      navigate(
        linkCheckSlash(
          location.pathname,
          isWorkshopService ? `${item.value}/${ageLinkValue}` : item.value,
        ),
      );
    });
  };

  let availableCitiesComponent = (
    <div>
      <LoadingBar />
    </div>
  );
  if (availableCities) {
    availableCitiesComponent = (
      <AccordionWithSearch
        small
        data={availableCities}
        selected={currentCity}
        onClick={handleSelection}
        placeholder={cityPageTexts.placeholder}
      />
    );
  }

  const content = (
    <div>
      <FormLabel type="big">{cityFormLabel}</FormLabel>
      {availableCitiesComponent}
    </div>
  );

  return (
    <SingleInputPage
      setLoading={setLoading}
      genericMessageType={genericModelTypes.noService}
      page={currentPage}
      currentStep={currentPage.step}
      content={content}
      backButton={true}
      nextButton={currentCity && !loading}
      nextButtonLink={
        isWorkshopService
          ? `./${currentCity?.value}/${ageLinkValue}`
          : `./${currentCity?.value}`
      }
      errorMessage={false}
      loading={loading}
    />
  );
}
